import React from 'react';
import './userPanelContentSkeleton.css';

const SKELETON_CONFIG = {
  movies: {
    label: 'Filmler yükleniyor',
    cardCount: 18,
  },
  series: {
    label: 'Diziler yükleniyor',
    cardCount: 18,
  },
  webtv: {
    label: 'Canlı TV kanalları yükleniyor',
    cardCount: 21,
  },
};

function UserPanelContentSkeleton({ variant = 'movies' }) {
  const config = SKELETON_CONFIG[variant] || SKELETON_CONFIG.movies;
  const isWebTv = variant === 'webtv';

  return (
    <div
      className={`tvup-content-skeleton is-${variant}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={config.label}
      data-testid={`${variant}-initial-skeleton`}
    >
      <span className="tvup-content-skeleton-accessible">{config.label}</span>

      <section className="tvup-content-skeleton-category" aria-hidden="true">
        <div className="tvup-content-skeleton-heading">
          <span className="tvup-content-skeleton-shape is-heading" />
          <span className="tvup-content-skeleton-shape is-caption" />
        </div>
        <div className="tvup-content-skeleton-categories">
          {Array.from({ length: 7 }, (_, index) => (
            <span key={index} className="tvup-content-skeleton-shape is-category-card">
              <i />
              <b />
              <small />
            </span>
          ))}
        </div>
      </section>

      <section className="tvup-content-skeleton-library" aria-hidden="true">
        <div className="tvup-content-skeleton-toolbar">
          <span className="tvup-content-skeleton-toolbar-copy">
            <i className="tvup-content-skeleton-shape" />
            <b className="tvup-content-skeleton-shape" />
          </span>
          <span className="tvup-content-skeleton-shape is-search" />
        </div>

        <div className={`tvup-content-skeleton-grid${isWebTv ? ' is-channel-grid' : ''}`}>
          {Array.from({ length: config.cardCount }, (_, index) => (
            <span key={index} className={`tvup-content-skeleton-card${isWebTv ? ' is-channel' : ''}`}>
              <i className="tvup-content-skeleton-shape is-media" />
              <b className="tvup-content-skeleton-shape" />
              <small className="tvup-content-skeleton-shape" />
            </span>
          ))}
        </div>
      </section>
    </div>
  );
}

export default UserPanelContentSkeleton;
